<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  			<li class="m-nav__item">
		  				<router-link :to="{name: 'home'}">
		  					<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
		  					</span>
		  				</router-link>
		  			</li>
		  			<li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{'property_administration' | translate | titleize}}
		  					</span>
		  			</li>
            <li class="m-nav__separator">
		  				>
		  			</li>
            <li class="m-nav__item">
		  					<span class="m-nav__link-text">
		  						{{'departments' | translate | titleize}}
		  					</span>
		  			</li>
            <li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  				<span class="m-nav__link-text">
		  					{{'authorized_by_department' | translate | titleize}}
		  				</span>
		  			</li>
		  		</ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon">
                <i class="flaticon-suitcase"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{'authorized_by_department' | capitalize}}
              </h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
              <li class="m-portlet__nav-item">
                <a v-if="validPermission('create','access_profile')" href="#" class="btn btn-success m-btn m-btn--icon" data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#access_profile_modal" @click.stop.prevent="showModal">
							    <span>
                    <i class="fa fa-plus"></i>
                    <span>
                      {{'group_edit' | translate | capitalize }}
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div class="col-lg-3">
              <label for="department">{{ 'department' | capitalize }}</label>
              <select id="department" class="form-control m-bootstrap-select m_selectpicker" v-model="filters.department" :title="'select_department'| capitalize">
                <option v-for="(local_department, local_index) in departments" :key="local_index" :value="local_department.id">{{ local_department.name | translate | capitalize }}</option>
              </select>
            </div>
            <div class="col-lg-3">
              <label for="identification_number">{{ 'identification_number' | capitalize }}</label>
              <input id="identification_number" type="text" v-model="filters.identification" name="identification_number" class="form-control m-input">
            </div>
            <div class="col-lg-3">
              <label for="access_profile">{{ 'access_profile' | capitalize }}</label>
              <select id="access_profile" class="form-control m-bootstrap-select m_selectpicker" v-model="filters.access_profile">
                <option value="">{{'all' | capitalize}}</option>
                <option v-for="(local_access_profile, local_index) in access_profiles" :key="local_index" :value="local_access_profile.id">{{ local_access_profile.name | translate | capitalize }}</option>
              </select>
            </div>
            <div class="col-lg-2">
              <label for="authorized_type">{{ 'authorized_type' | capitalize }}</label>
              <select id="authorized_type" class="form-control m-bootstrap-select m_selectpicker" v-model="filters.authorized_type">
                <option value="">{{'all' | capitalize}}</option>
                <option v-for="(local_authorized_type, local_index) in authorized_types" :key="local_index" :value="local_authorized_type.id">{{ local_authorized_type.name | translate | capitalize }}</option>
              </select>
            </div>
            <div class="col-lg-1">
              <label>&nbsp;</label>
              <button class="btn btn-success" id="btn-cancel" @click="filter">
                <i class="la la-search"></i>
              </button>
            </div>
          </div>
          <s-datatable :config="datatable" @checks="updateChecks">
            <!-- <div slot="actions" slot-scope="props">
              <a  href="#" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit"  data-toggle="modal" data-backdrop="static" data-keyboard="false" data-target="#department_modal">
                <i class="la la-edit"></i>
              </a>
            </div> -->
          </s-datatable>
        </div>
      </div>
      <s-modal id="access_profile_modal" :title="'create_access_profile' | translate | capitalize">
        <s-access-profile v-show="!modal_access_day" slot="body" :authorizations="check_ids" :view="view" @setView="setView" @setAccessDay="setAccessDay" @setAccessProfile="setAccessProfile"></s-access-profile>
        <s-access-day v-show="modal_access_day" slot="body" :edit_group="edit_group" @setEditGroup="setEditGroup" :open_outside="true" :data="access_day" :modal="true" :view="view"></s-access-day>
      </s-modal>
    </div>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SModal from '@/components/layout/modal/Modal.vue'
import SDatatable from '@/components/layout/datatable/Datatable.vue'
import SAccessProfile from '@/components/admin/departments/authorized/New.vue'
import SAccessDay from '@/components/admin/access_day/New.vue'
export default {
  components: { SModal, SDatatable, SAccessProfile, SAccessDay },
  data () {
    return {
      filters: {
        access_profile: '',
        authorized_type: '',
        department: '',
        identification: ''
      },
      datatable: {},
      departments: [],
      authorized_types: [],
      access_profiles: [],
      check_ids: [],
      access_profile: {},
      access_day: [],
      view: false,
      edit_group: false
    }
  },
  computed: {
    department () {
      return this.filters.department
    },
    data () {
      return { access_profile: Object.assign(this.access_day, this.access_profiles) }
    },
    ...mapGetters({modal: 'getStatusAccessProfileModal', permissions: 'getUserPermissions', modal_access_day: 'getModalAccessDay'})
  },
  mounted () {
    const department = this.$route.params.department
    if (!department) {
      this.$router.push({ name: 'adminDepartment' })
    } else {
      this.retrieveDepartment()
        .then((res) => {
          if (res.status === 200) {
            if (department === undefined) {
              this.filters.department = ''
            } else {
              this.filters.department = department.id
            }
            this.departments = res.data
            const self = this
            Vue.nextTick()
              .then(function () {
                window.$('#department').selectpicker('refresh')
                window.$('#department').selectpicker('val', self.filters.department)
              })
            this.retrieveFiltersData(department.id)
          }
        })
        .catch((err) => {
          this.$toast('error_occurred', 4)
          console.log(err)
        })

      const self = this
      const datatable = {
        url: '/api/authorization',
        method: 'POST',
        size: 15,
        columns: [
          {
            field: 'name',
            title: 'names',
            template (row) {
              return `${row.person.first_name} ${row.person.last_name}`
            }
          },
          {
            field: 'identification_number',
            title: 'identification_number',
            template (row) {
              return `${row.person.identification_types.abbreviation} ${row.person.identification_number}`
            }
          },
          {
            field: 'access_profile',
            title: 'access_profile',
            template (row) {
              let message = row.access_profile.is_personalized === 1 ? self.$options.filters.capitalize('personalized') : `${row.access_profile.name}`
              return message
            }
          },
          {
            field: 'authorized_type',
            title: 'authorized_type',
            template (row) {
              return `${row.access_profile.authorized_type.name}`
            }
          },
          {
            field: 'state',
            title: 'state',
            template: function (row) {
              var status = {
                1: {'title': self.$options.filters.capitalize('active'), 'class': 'm-badge--success'},
                0: {'title': self.$options.filters.capitalize('inactive'), 'class': ' m-badge--danger'},
                null: {'title': self.$options.filters.capitalize('unknown'), 'class': 'm-badge--brand'}
              }
              return '<span class="m-badge ' + status[row.state].class + ' m-badge--wide">' + status[row.state].title + '</span>'
            }
          }],
        actions: false,
        update: false,
        query: { department: department.id, person_document: this.filters.identification, authorized_type: this.filters.authorized_type, access_profile: this.filters.access_profile },
        check: true
      }
      this.datatable = datatable
    }
  },
  methods: {
    ...mapActions(['retrieveDepartment', 'retrieveDetailsAPByDepartment', 'changeAccessProfileStatus', 'setStatusAccessProfileModal', 'setStatusEditAccessDay', 'setStatusLoadDataAccessDay']),
    updateChecks (ids) {
      this.check_ids = ids
    },
    filter () {
      this.datatable.update = true
      this.datatable.query = { department: this.filters.department, person_document: this.filters.identification, authorized_type: this.filters.authorized_type, access_profile: this.filters.access_profile }
    },
    cleanFilters () {
      this.filters.access_profile = ''
      this.filters.authorized_type = ''
    },
    validPermission (action, entity) {
      if (this.permissions.find(p => { return (p.action === action && p.entity === entity) })) {
        return true
      } else {
        return false
      }
    },
    showModal () {
      if (this.check_ids.length > 0) {
        window.$('#access_profile_modal').modal('show')
        this.setStatusAccessProfileModal(true)
      } else {
        swal({
          type: 'error',
          title: this.$options.filters.capitalize('check_authorized_persons'),
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    retrieveFiltersData (department_id) {
      this.$spinner.show()
      this.retrieveDetailsAPByDepartment(department_id)
        .then((res) => {
          this.authorized_types = res.data.authorized_types
          this.access_profiles = res.data.access_profiles.filter(ap => ap.is_personalized === 0)
          Vue.nextTick()
            .then(function () {
              window.$('#authorized_type').selectpicker('refresh')
              window.$('#access_profile').selectpicker('refresh')
            })
        })
        .catch((err) => {
          this.$toast('error_occurred', 4)
          console.log(err)
          this.$spinner.remove()
        })
    },
    setView (value) {
      this.view = value
    },
    setAccessDay (value) {
      this.access_day = value
      this.edit_group = true
    },
    setAccessProfile (value) {
      this.access_profile = value
    },
    setEditGroup (value) {
      this.edit_group = value
    }
  },
  watch: {
    department (newVal, oldVal) {
      this.retrieveFiltersData(newVal)
      this.filter()
      this.cleanFilters()
    },
    modal (newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.datatable.update = true
        this.access_profile = { control_points: [] }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// All.vue